import classNames from "classnames";
import { UserAvatar } from "components/Atoms/Avatar";
import { ButtonPrimary } from "components/Atoms/Button";
import { PhosphorChatTeardropDots, PhosphorCheck } from "components/Atoms/PhosphorIcon";
import { PhosphorXButton } from "components/Atoms/PhosphorIconButton";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc, newLineToBr } from "utilities";

interface Props {
  message: server.dto.AdvancingMessage
  isIncoming: boolean
  isMarkingSeen: boolean
  onMarkSeen: () => void
  onClose?: () => void
  isToast?: boolean
}

export const AdvancingChatRow = (props: Props) => {
  const timestampUtc = moment.utc(props.message.timestampUtc);

  return <div className={classNames("flex-column gap padding-large radius", { "card-surface-standalone": !props.isToast })}>
    <div className="flex gap-large">
      <UserAvatar user={props.message.actorUser} />
      <div className="grow1 flex-column gap-small">
        <div className="flex justify-space-between gap">
          <div>{props.message.actorUser.fullName}</div>
          <div className="flex align-center gap">
            <div className="text-sublabel" title={formatWrittenDateTimeUtc(timestampUtc)}>{timestampUtc.fromNow()}</div>
            {props.onClose && <PhosphorXButton layout="none" onClick={props.onClose} />}
          </div>
        </div>
        <div className="advancing-message-body">{newLineToBr(props.message.body)}</div>
      </div>
    </div>
    {!props.message.seenUtc && <div className="flex align-center justify-end">
      {props.isIncoming
        ? <ButtonPrimary className="advancing-chat-read-button" iconLeft={PhosphorCheck} label="Read" loading={props.isMarkingSeen} onClick={props.onMarkSeen} />
        : <div className="advancing-chat-unread flex align-center gap-small">
          <PhosphorChatTeardropDots iconSize="small" />
          Unread
        </div>}
    </div>}
  </div>;
};
